import BaseListPresenter from "../../../base/BaseListPresenter";
import DeleteModal from "../../../components/common/DeleteModal";
import { dialog } from "nq-component";
import { printComponent } from "nq-component";
import { _withItem } from "../../EmployeeSelfService/Payslip/print-payslip/PayslipHelper";

class PayslipAdminPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async handlePrint(data) {
    const checkCase = _withItem(data);

    const [salaryGrade, accountsTitle] = await Promise.all([
      this.findObjectUseCase.execute("salary_grade", {
        where: {
          salaryCode: data?.employee?.salaryCode,
        },
        sort: { createdAt: -1 },
        keys: ["salaryCode", "Year", "Monthly Rate"],
      }),
      this.findObjectUseCase.execute("accounts_title", {
        keys: ["name", "payslipLabel"],
      }),
    ]);

    const monthlyRate = salaryGrade[0]?.["Monthly Rate"];

    let payrollData;

    if (
      checkCase("isBasicJoAddendum") ||
      checkCase("isBasicBackpay") ||
      checkCase("isApBackPay")
    ) {
      const backpayData = await this.findObjectUseCase.execute(
        "payroll_back_pay",
        {
          where: {
            payrollID: data?.payrollID,
            "employee.id": data?.employee.id,
          },
          include: ["employee"],
        }
      );
      payrollData = backpayData;
    } else {
      const nonBackpayData = await this.findObjectUseCase.execute("payroll", {
        where: {
          payrollID: data?.payrollID,
          "employee.id": data?.employee.id,
        },
        include: ["employee"],
      });
      payrollData = nonBackpayData;
    }

    this.view.setState({ payrollData, accountsTitle, monthlyRate });

    printComponent(this.view.contractPDF.current);
  }

  handleDeleteData(data) {
    const id = data.id;
    DeleteModal(async () => {
      await this.deleteObjectUseCase.execute("payslip", id);
      this.view.refetchData();
      dialog.close();
      this.view.showSuccess("Record Deleted Succesfully!");
    });
  }
}
export default PayslipAdminPresenter;
